import { createSignal } from 'solid-js';

import { COUNTRY_CODE } from '~/lib/graphql/types';

// ---------------------------------------------------------------------------
// Locale data
// ---------------------------------------------------------------------------

export interface LocaleData {
    localeString: string;
    currency: string;
    currencyCode: string;
    support: {
        number: string;
        email: string;
    };
}

const locales: Record<COUNTRY_CODE, LocaleData> = {
    [COUNTRY_CODE.SG]: {
        localeString: 'en-SG',
        currency: 'S$',
        currencyCode: 'SGD',
        support: {
            number: '+6587796122',
            email: 'sales@getsolar.ai'
        }
    },
    [COUNTRY_CODE.MY]: {
        localeString: 'en-MY',
        currency: 'RM',
        currencyCode: 'MYR',
        support: {
            number: '+60183585204',
            email: 'sales@getsolar.ai'
        }
    }
};

// ---------------------------------------------------------------------------
// Signal-based locale switcher
// ---------------------------------------------------------------------------

const [countryCode, setCountryCode] = createSignal<COUNTRY_CODE>(
    COUNTRY_CODE.SG
);

/** Current locale data (reactive). */
export function locale(): LocaleData {
    return locales[countryCode()];
}

/** Current country code (reactive). */
export { countryCode };

/** Switch the active locale by country code. */
export { setCountryCode };
